'use client';

import ButtonAccount from '@/components/header/ButtonAccount';
import { useTranslations } from 'next-intl';
import dynamic from 'next/dynamic';
import useSession from '../../stores/session/useSession';
import { Button } from '../design-system';
import ButtonCart from './ButtonCart';
import ButtonOtto from '@/components/header/ButtonOtto';

const LinkToLogin = dynamic(() => import('../design-system/LinkToLogin'), {
  ssr: false,
});

export default function RightButtons() {
  const t = useTranslations('common');
  const { user } = useSession();

  return (
    <div className="flex items-center gap-1">
      {!user && (
        <div className="mr-2">
          <LinkToLogin>
            <Button palette="gray" type="link">
              {t('action.login')}
            </Button>
          </LinkToLogin>
        </div>
      )}
      <ButtonOtto />
      <ButtonCart />
      <ButtonAccount />
    </div>
  );
}
